import { L } from '@lang';
import { Trans } from 'react-i18next';
import { imageGetters } from '../../helpers/imageGetters';
import { Header } from '../../widgets/Header';
import { Instruction, InstallPage } from '../../shared/ui';
import { ReactComponent as InstallIcon } from './assets/share.svg';
import styles from './PwaInstallOldSafari.module.css';

export function PwaInstallOldSafari() {
  return (
    <InstallPage>
      <Header />
      <Instruction>
        <Instruction.Item
          title={
            <Trans
              i18n={L.i18n}
              i18nKey="pwa_install_old_safari_step1_title"
              components={{ icon: <InstallIcon className={styles.download} /> }}
            />
          }
          srcSet={imageGetters.oldSafari('step1-light')}
          darkSrcSet={imageGetters.oldSafari('step1-dark')}
          aspectRatio={351 / 96}
        />
        <Instruction.Item
          title={L.t('pwa_install_old_safari_step2_title')}
          srcSet={imageGetters.oldSafari('step2-light')}
          darkSrcSet={imageGetters.oldSafari('step2-dark')}
          aspectRatio={351 / 128}
        />
        <Instruction.Item title={L.t('pwa_install_old_safari_step3_title')} />
      </Instruction>
    </InstallPage>
  );
}
